import { render, staticRenderFns } from "./ApplicationFooter.vue?vue&type=template&id=5b4339f0&scoped=true&"
import script from "./ApplicationFooter.vue?vue&type=script&lang=js&"
export * from "./ApplicationFooter.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFooter.vue?vue&type=style&index=0&id=5b4339f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4339f0",
  null
  
)

export default component.exports